import { gql, useMutation } from "@apollo/client";

const MUTATION = gql`
  mutation UnfollowUser($removeInnerCircleOnly: Boolean, $userId: ID!) {
    unfollowUser(removeInnerCircleOnly: $removeInnerCircleOnly, userId: $userId) {
      success
    }
  }
`;

interface DataType {
  unfollowUser: {
    success: boolean;
  };
}

interface VariablesType {
  removeInnerCircleOnly?: boolean;
  userId: string;
}

export default function useUnfollowUser() {
  return useMutation<DataType, VariablesType>(MUTATION);
}
